import { Outlet } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import Layout from "../../organisms/Layout/Layout";
import type { DashboardProps } from "./Dashboard.types";
import BuildIcon from "@mui/icons-material/Build";
import { useState } from "react";
import SystemInfoDialog from "../../organisms/SystemInfoDialog/SystemInfoDialog";

export const Dashboard = ({
    children,
    testId = "dashboard",
    mainMenuItems,
    accountMenuItems,
}: DashboardProps) => {
    const { t } = useTranslation("common", {
        keyPrefix: "dashboard",
    });

    const [openSystemInfoDialog, setOpenSystemInfoDialog] = useState(false);

    return (
        <>
            <Layout
                data-testid={testId}
                appBar={{
                    accountMenu: {
                        tooltip: t("menu.account"),
                        items: accountMenuItems,
                    },
                }}
                mainMenu={{
                    items: [
                        mainMenuItems.filter(
                            (item) => Object.keys(item).length > 0
                        ),
                    ],
                }}
                actionButton={{
                    icon: <BuildIcon fontSize="small" />,
                    text: t("system-info"),
                    onClick: () => {
                        setOpenSystemInfoDialog(true);
                    },
                }}
            >
                {children ? children : <Outlet />}
            </Layout>
            {openSystemInfoDialog ? (
                <SystemInfoDialog
                    open={openSystemInfoDialog}
                    onClose={() => setOpenSystemInfoDialog(false)}
                />
            ) : null}
        </>
    );
};

export default Dashboard;
